import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "@store/store";
import { BROWSER_ROUTES } from "@constants/browser.routes";

interface AuthGuardProps {
	children: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
	const { isAuthenticated } = useSelector((state: RootState) => state.user);
	const location = useLocation();

	if (!isAuthenticated) {
		// Redirect to login page but save the attempted url
		return <Navigate to={BROWSER_ROUTES.LOGIN} state={{ from: location }} replace />;
	}

	return <>{children}</>;
};

export default AuthGuard;
